module.exports = __webpack_public_path__ + "static/media/Illus-Delivery_2@3x.d5a27ba4.png";